import { useCallback, useEffect, useState } from 'react';
import { getTicket } from '../api/tickets';
import { Ticket } from '../types/ticket';

export function useTicket(ticketId: string | undefined) {
  const [ticket, setTicket] = useState<Ticket | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!ticketId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await getTicket(ticketId);
      setTicket(res.ticket);
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [ticketId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { ticket, loading, error, refetch: fetch };
}
